import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/sections/HeroSection';
import TrustBar from '../components/sections/TrustBar';
import ProblemSolution from '../components/sections/ProblemSolution';
import FeaturesGrid from '../components/sections/FeaturesGrid';
import HowItWorks from '../components/sections/HowItWorks';
import SecuritySection from '../components/sections/SecuritySection';
import CrossPlatformSection from '../components/sections/CrossPlatformSection';
import FAQPreview from '../components/sections/FAQPreview';
import FinalCTA from '../components/sections/FinalCTA';

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>Docudi – Smart Document Scanner & Manager</title>
        <meta name="description" content="Scan, organize, and manage your documents digitally. Docudi is the professional document scanner app that saves you time and keeps your files secure." />
        <link rel="canonical" href="https://[YOUR-DOMAIN.com]/" />
        <meta property="og:title" content="Docudi – Smart Document Scanner & Manager" />
        <meta property="og:description" content="Scan, organize, and manage your documents digitally. The professional document scanner app for teams and individuals." />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Docudi",
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "iOS, Android",
            "description": "Professional document scanner and manager app"
          }
        `}</script>
      </Helmet>
      <HeroSection />
      <TrustBar />
      <ProblemSolution />
      <FeaturesGrid />
      <HowItWorks />
      <SecuritySection />
      <CrossPlatformSection />
      {/* PricingPreview hidden — pricing removed from site */}
      {/* <PricingPreview /> */}
      {/* TestimonialsSection hidden — awaiting real reviews */}
      {/* <TestimonialsSection /> */}
      <FAQPreview />
      <FinalCTA />
    </>
  );
}
